@import '~style-sheet-helpers/core.less';
@import '../component.module.less';

.input-row {
  display: flex;
  width: 100%;
  justify-content: space-between;
  gap: 8px;
}

.name-input {
  .grid-full-width();
  position: relative;
}

.button-row {
  display: flex;
  justify-content: flex-end;
  padding-top: 5px;
  margin-top: 10px;
}

.add-margin {
  margin-right: 5px;
}

.edit-address-wrapper {
  margin-top: 15px;
}

.auto-correct-checkbox {
  padding-top: 10px;
  height: 24px;
  margin-right: auto;
}

/* On smaller screens make each component its own line */
@media screen and (max-width: 1499px) {
  .state-section-wrapper {
    .grid-full-width();
  }

  .state-input {
    .grid-full-width();
  }

  .postal-code-label {
    grid-column: col-start / span 1;
  }

  .zip-code-label {
    grid-column: col-start / span 1;
  }

  .postal-code-input {
    .grid-full-width();
  }

  .phone-number {
    .grid-full-width();
  }
}
